
import {createSlice} from '@reduxjs/toolkit'
import { fetchschedule } from '../../action/master/scheduleAction'

interface scheduleState {
  data: any
  status: 'idle' | 'loading' | 'succeeded' | 'failed'
  error: string | null
}

const initialState: scheduleState = {
  data: null,
  status: 'idle',
  error: null,
}

const scheduleSlice = createSlice({
  name: 'schedule',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchschedule.pending, (state) => {
        state.status = 'loading'
      })
      .addCase(fetchschedule.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.data = action.payload
        
      })
      .addCase(fetchschedule.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message || 'Failed to fetch business type data'
      })
  },
})

export default scheduleSlice.reducer
